export const bodyFreeze = function () {
  var body = document.body;
  var outer = document.createElement('div');
  outer.style.visibility = 'hidden';
  outer.style.overflow = 'scroll';
  outer.style.msOverflowStyle = 'scrollbar';
  document.body.appendChild(outer);
  var inner = document.createElement('div');
  outer.appendChild(inner);
  var scrollbarWidth = outer.offsetWidth - inner.offsetWidth;
  outer.parentNode.removeChild(outer);
  body.classList.add('_freeze');
  body.style.paddingRight = scrollbarWidth + 'px';
};

export const bodyUnfreeze = function () {
  var body = document.body;
  if (!body.classList.contains('_freeze')) {
    return;
  }
  body.removeAttribute('style');
  body.classList.remove('_freeze');
};
